module.exports = __webpack_public_path__ + "media/inventory.0ebd51d8.mp4";